export function isPublicPlatformPath(pathname: string): boolean {
  return (
    pathname === "/" ||
    pathname === "/platform" ||
    pathname.startsWith("/platform/") ||
    pathname === "/platforms" ||
    pathname === "/store"
  );
}
